import React from "react";
import pageStyles from "../styles/PageLayout.module.css";
import PageHeader from "../shared/PageHeader";
import PageContent from "../shared/PageContent";
import RouletteSection from "../sections/RouletteSection";

export function RoulettePageAdmin({ roulette }) {
  return (
    <div className={pageStyles.page}>
      <PageHeader
        title="Рулетка"
        description="Управляйте бесплатным и платным пулом призов, весами, наградами и сообщениями."
      />
      <PageContent>
        <RouletteSection mode="page" state={roulette.state} actions={roulette.actions} />
      </PageContent>
    </div>
  );
}

export default RoulettePageAdmin;
